import { useTranslate } from '@tolgee/react';
import classNames from 'classnames';

interface OnOffButtonProps {
  value: boolean;
  onChange: (newValue: boolean) => void;
  'data-testid'?: string;
  disabled?: boolean;
}

export default function OnOffButton(props: OnOffButtonProps) {
  const { value, onChange, disabled } = props;
  const { t } = useTranslate();

  return (
    <div className="flex rounded-md shadow-sm">
      <button
        type="button"
        onClick={() => {
          onChange(true);
        }}
        disabled={disabled}
        className={classNames(
          'relative inline-flex items-center px-3 py-1 text-sm font-medium rounded-l-md',
          value ? 'bg-indigo-600 text-white' : 'bg-white text-gray-500 hover:bg-gray-50 border border-gray-300',
          disabled && 'opacity-50 cursor-not-allowed'
        )}
        data-testid={props['data-testid'] ? `${props['data-testid']}-on` : undefined}
      >
        {t('common.on', 'On')}
      </button>
      <button
        type="button"
        onClick={() => {
          onChange(false);
        }}
        disabled={disabled}
        className={classNames(
          'relative inline-flex items-center px-3 py-1 text-sm font-medium rounded-r-md',
          !value ? 'bg-indigo-600 text-white' : 'bg-white text-gray-500 hover:bg-gray-50 border border-gray-300',
          disabled && 'opacity-50 cursor-not-allowed'
        )}
        data-testid={props['data-testid'] ? `${props['data-testid']}-off` : undefined}
      >
        {t('common.off', 'Off')}
      </button>
    </div>
  );
}
